export default __webpack_public_path__ + "static/media/Hourglass.55d157a0.gif";